import LogoutComponent from "../components/logout.vue";
import InicioComponent from "@/views/Inicio.vue";
import CadastroSuspensaoAdvogadosComponent from "@/views/oab/CadastroSuspensaoAdvogados.vue";

const geralRotas = [
  {
    path: "/inicio",
    name: "inicio",
    component: InicioComponent,
  },
  {
    path: "/sair",
    name: "sair",
    component: LogoutComponent,
    props: true,
  },
  {
    path: "/oab/cadastro-suspensao-advogados",
    name: "oab--cadastro--suspensao-advogados",
    component: CadastroSuspensaoAdvogadosComponent,
  },
];

export { geralRotas };
